import {CRUDService} from "rw-api-common-ts";

import {
  Package,
  CreatePackageDto,
  UpdatePackageDto,
} from "tiolem-bgolan-shared";

import {apiClient} from "modules/api";
import {AxiosResponse} from "axios";
import {RWMap} from "rw-ts-common/data-sturctures";

class PackageApi extends CRUDService<
  Package,
  CreatePackageDto,
  UpdatePackageDto
> {
  readonly apiUrl = `${apiClient.apiBaseUrl}/packages`;
  readonly entityName = "packages";

  constructor() {
    super({apiClient});
  }

  async create(createDto: CreatePackageDto): Promise<Package> {
    const entity = await super.createEntity(createDto);
    return entity;
  }

  async patch(updateDto: UpdatePackageDto): Promise<Package> {
    const entity = await super.patchEntity(updateDto.id!, updateDto);

    return entity;
  }

  async getEntities(filter?: any): Promise<RWMap<Package>> {
    try {
      const urlSearchParams = filter as URLSearchParams;

      const response = (await this.apiClient.http.get(
        `${this.apiUrl}${
          urlSearchParams ? "?" + urlSearchParams.toString() : ""
        }`,
      )) as AxiosResponse<Package[]>;

      const entities = response.data;
      const mapEntities = RWMap.createFromArray<Package>({
        arr: entities,
        keyPropName: "id",
      });

      return mapEntities;
    } catch (err) {
      throw err;
    }
  }
}

export const packageApi = new PackageApi();
